import { connect } from 'react-redux';
import { BUILDER, PUBLISH_FACILITY_PAGES, PUBLISH_NON_FACILITY_PAGES } from 'shared/abilities';
import { canMakeLive, getLiveCopy, makeLive, switchLiveAndDraft } from 'web/store/modules/pages';
import {
  getId,
  isEditingPage,
  hasFacility,
  isPageLive,
  isPublishing,
  currentVersionIsPublished,
  publishCurrent,
  getRestoreMode, // Import selector for restoreMode
  getSelectedMajorVersion, // Import selector for selectedMajorVersion
  getVersion, // Import selector for version
  publishMajorVersion,
} from 'web/store/modules/pageBuilder';
import withUserAuth from '../hocs/withUserAuth';
import PublishButton from '../components/PublishButton';

const mapStateToProps = (state) => {
  const id = getId(state);
  const editingPage = isEditingPage(state);

  let pageProps = {};
  if (editingPage) {
    const page = state.pageBuilder;

    pageProps = {
      page,
      live: isPageLive(state),
      canMakePageLive: canMakeLive(state, page),
      livePageCopy: getLiveCopy(state, page),
    };
  }

  return {
    id,
    editingPage,
    facility: hasFacility(state),
    publishing: isPublishing(state),
    published: currentVersionIsPublished(state),
    restoreMode: getRestoreMode(state), // Add restoreMode from the store
    selectedMajorVersion: getSelectedMajorVersion(state), // Add selectedMajorVersion from the store
    version: getVersion(state), // Add version from the store
    ...pageProps,
  };
};

const mapDispatchToProps = null;

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { userIsAuthorized, ...restOfOwnProps } = ownProps;
  const { dispatch } = dispatchProps;
  const {
    canMakePageLive,
    id,
    live,
    livePageCopy,
    editingPage,
    facility,
    page,
    published,
    restoreMode, // Access restoreMode from stateProps
    selectedMajorVersion, // Access selectedMajorVersion from stateProps
    version, // Access version from stateProps
    ...restOfStateProps
  } = stateProps;

  const authorized = userIsAuthorized({
    action: 'manage',
    subject: [
      BUILDER,
      facility ? PUBLISH_FACILITY_PAGES : PUBLISH_NON_FACILITY_PAGES,
    ],
  });

  const target = editingPage ? 'page' : 'layout';
  const authText = authorized
    ? undefined
    : `You do not have permission to publish this ${target}.`;

  let helpText = restoreMode
    ? `Restore this ${target} to the selected version.`
    : `This ${target} has unpublished changes.`;
  if (editingPage && !live && !restoreMode) {
    helpText = `Publishing this ${target} will make it live on your site.`;
  } else if (published && !restoreMode) {
    helpText = `This ${target} has no changes to publish.`;
  }

  let onClick;
  if (editingPage) {
    if (restoreMode) {
      onClick = () => dispatch(publishMajorVersion(id, selectedMajorVersion.id)); // Corrected action call
    } else if (live) {
      onClick = () => dispatch(publishCurrent(id));
    } else if (canMakePageLive) {
      onClick = () => dispatch(makeLive(page));
    } else {
      onClick = () => dispatch(switchLiveAndDraft(page, livePageCopy));
    }
  }

  let upToDate = false;
  if (editingPage && live && published && !restoreMode) {
    upToDate = true;
  } else if (!editingPage && published && !restoreMode) {
    upToDate = true;
  }

  return {
    ...restOfOwnProps,
    ...restOfStateProps,
    onClick,
    helpText,
    authText,
    disabled: !id || !authorized || upToDate,
    publishable: !upToDate,
    disableEnUsPage: page && page.disableEnUsPage,
    mode: restoreMode ? 'restore' : 'publish', // Pass mode based on restoreMode
    restoreMode, // Pass restoreMode to the component
  };
};

export default withUserAuth(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(PublishButton),
);
